
      import Template7 from 'template7';
      const Template7Helpers = Template7.helpers;
  
      
  
      export default {
  data: function () {
    //console.log(this);
    var article = this.$route.context.article; //            var currentArticle;
    //            this.$root.news.forEach(function (article) {
    //                if (article.id === articleId) {
    //                    currentArticle = article;
    //                }
    //            });

    return {
      photoBrowser: null,
      article: article,
      images: []
    };
  },

  mounted() {
    var self = this;
    var app = self.$app;
    var $$ = self.$dom7;
    console.log(self.article.images);
    console.log(self.article.videos);
    let images = [];
    self.article.videos.forEach((video, indx) => {
      images.push({
        html: '<video controls="controls" preload="metadata" width="100%" style="max-height: 90%">' + '<source src="' + video['url'] + '" type="video/mp4"/>' + '</video>',
        thumb: video['thumb']
      });
    });
    self.article.images.forEach((img, indx) => {
      images.push({
        url: img
      });
    });
    self.photoBrowser = app.photoBrowser.create({
      photos: images,
      theme: 'dark',
      navbarShowCount: false,
      type: 'standalone',

      renderToolbar() {
        const pb = this; //if (pb.params.renderToolbar) return pb.params.renderToolbar.call(pb);

        let iconsColor = pb.params.iconsColor;
        if (!pb.params.iconsColor && pb.params.theme === 'dark') iconsColor = 'white';
        let icon = `<i class="icon material-icons ${iconsColor ? `color-${iconsColor}` : ''}">share</i>`;

        if (app.device.ios) {
          icon = `<i class="icon f7-icons ${iconsColor ? `color-${iconsColor}` : ''}">square_arrow_up</i>`; //
        }

        const toolbarHtml = `
                              <div class="toolbar toolbar-bottom tabbar">
                                <div class="toolbar-inner">
                                  <a class="link share-current-photo">
                                    ${icon}
                                  </a>
                                </div>
                              </div>
                            `.trim();
        return toolbarHtml;
      }

    });
    self.images = images;
    self.$update(() => {
      var swiper = self.$app.swiper.get(".article-images-swiper");

      if (swiper) {
        swiper.update();
      }
    });
  },

  methods: {
    openImage(index) {
      var self = this;
      var app = self.$app;
      var $$ = self.$dom7;
      console.log(index);
      self.photoBrowser.open(index);
    }

  },
  id: '6df8d28282',

  render() {
    return function (ctx_1, data_1, root) {
      function isArray(arr) {
        return Array.isArray(arr);
      }

      function isFunction(func) {
        return typeof func === 'function';
      }

      function c(val, ctx) {
        if (typeof val !== "undefined" && val !== null) {
          if (isFunction(val)) {
            return val.call(ctx);
          } else return val;
        } else return "";
      }

      root = root || ctx_1 || {};
      var r = '';
      r += '\n    <div class="page no-toolbar" data-name="article">\n        <div class="navbar">\n            <div class="navbar-bg"></div>\n            <div class="navbar-inner sliding">\n                <div class="left">\n                    <a class="link back" href="#">\n                        <i class="icon icon-back"></i>\n                        <span class="if-not-md">\n                        ';
      r += Template7Helpers.unless.call(ctx_1, ctx_1.backButton, {
        hash: {},
        data: data_1 || {},
        fn: function (ctx_2, data_2) {
          var r = '';
          r += '\n                        Discover\n                        ';
          return r;
        },
        inverse: function (ctx_2, data_2) {
          var r = '';
          r += '\n                        ';
          r += c(ctx_2.backButton, ctx_2);
          r += '\n                        ';
          return r;
        },
        root: root,
        parents: [ctx_1]
      });
      r += '\n                        </span>\n                    </a>\n                </div>\n                <div class="title">';
      r += c(ctx_1.article.title, ctx_1);
      r += '</div>\n                <div class="right"></div>\n            </div>\n        </div>\n        <div class="page-content hide-navbar-on-scroll">\n            ';
      r += Template7Helpers.js_if.call(ctx_1, "this.article.gallery_style == 10", {
        hash: {},
        data: data_1 || {},
        fn: function (ctx_2, data_2) {
          var r = '';
          r += '\n            ';
          r += Template7Helpers.each.call(ctx_2, ctx_2.images, {
            hash: {},
            data: data_2 || {},
            fn: function (ctx_3, data_3) {
              var r = '';
              r += '\n            ';
              r += Template7Helpers.if.call(ctx_3, ctx_3.thumb, {
                hash: {},
                data: data_3 || {},
                fn: function (ctx_4, data_4) {
                  var r = '';
                  r += '\n            <div class="video-container" style="width: 100%;height: auto;max-height: 70%;overflow: hidden;">\n                <img src="';
                  r += c(ctx_4.thumb, ctx_4);
                  r += '" @click="openImage(';
                  r += c(data_4 && data_4.index, ctx_4);
                  r += ')" style="width: 100%;height: auto">\n                <div class="play-button-container">\n                    <div class="play-button">\n                        <i class="icon material-icons">play_arrow</i>\n                    </div>\n                </div>\n            </div>\n            ';
                  return r;
                },
                inverse: function (ctx_4, data_4) {
                  var r = '';
                  r += '\n            <img src="';
                  r += c(ctx_4.url, ctx_4);
                  r += '" @click="openImage(';
                  r += c(data_4 && data_4.index, ctx_4);
                  r += ')" style="width: 100%;height: auto">\n            ';
                  return r;
                },
                root: root,
                parents: [ctx_2, ctx_1]
              });
              r += '\n            ';
              return r;
            },
            inverse: function empty() {
              return '';
            },
            root: root,
            parents: [ctx_1]
          });
          r += '\n            ';
          return r;
        },
        inverse: function empty() {
          return '';
        },
        root: root,
        parents: [ctx_1]
      });
      r += '\n\n            ';
      r += Template7Helpers.js_if.call(ctx_1, "this.article.gallery_style == 20", {
        hash: {},
        data: data_1 || {},
        fn: function (ctx_2, data_2) {
          var r = '';
          r += '\n            <div class="row no-gap">\n                ';
          r += Template7Helpers.each.call(ctx_2, ctx_2.images, {
            hash: {},
            data: data_2 || {},
            fn: function (ctx_3, data_3) {
              var r = '';
              r += '\n                ';
              r += Template7Helpers.if.call(ctx_3, ctx_3.thumb, {
                hash: {},
                data: data_3 || {},
                fn: function (ctx_4, data_4) {
                  var r = '';
                  r += '\n                <div class="col-50">\n                    <div class="video-container"  style="padding-bottom: 100%;position:relative;">\n                        <img src="';
                  r += c(ctx_4.thumb, ctx_4);
                  r += '" @click="openImage(';
                  r += c(data_4 && data_4.index, ctx_4);
                  r += ')" style="width: 100%;height: 100%;object-fit: cover;position: absolute;top: 0;left: 0">\n                        <div class="play-button-container">\n                            <div class="play-button">\n                                <i class="icon material-icons">play_arrow</i>\n                            </div>\n                        </div>\n                    </div>\n                </div>\n                ';
                  return r;
                },
                inverse: function (ctx_4, data_4) {
                  var r = '';
                  r += '\n                <div class="col-50">\n                    <div style="padding-bottom: 100%;position:relative;">\n                        <img src="';
                  r += c(ctx_4.url, ctx_4);
                  r += '" @click="openImage(';
                  r += c(data_4 && data_4.index, ctx_4);
                  r += ')" style="width: 100%;height: 100%;object-fit: cover;position: absolute;top: 0;left: 0">\n                    </div>\n                </div>\n                ';
                  return r;
                },
                root: root,
                parents: [ctx_2, ctx_1]
              });
              r += '\n                ';
              return r;
            },
            inverse: function empty() {
              return '';
            },
            root: root,
            parents: [ctx_1]
          });
          r += '\n            </div>\n            ';
          return r;
        },
        inverse: function empty() {
          return '';
        },
        root: root,
        parents: [ctx_1]
      });
      r += '\n\n\n            ';
      r += Template7Helpers.js_if.call(ctx_1, "this.article.gallery_style == 30", {
        hash: {},
        data: data_1 || {},
        fn: function (ctx_2, data_2) {
          var r = '';
          r += '\n            <div class="swiper-container article-images-swiper swiper-init" data-pagination=\'{"el": ".swiper-pagination"}\' data-autoplay=\'{"delay": 3000, "disableOnInteraction":true}\'>\n                <div class="swiper-wrapper align-items-center">\n                    ';
          r += Template7Helpers.each.call(ctx_2, ctx_2.images, {
            hash: {},
            data: data_2 || {},
            fn: function (ctx_3, data_3) {
              var r = '';
              r += '\n                        ';
              r += Template7Helpers.if.call(ctx_3, ctx_3.thumb, {
                hash: {},
                data: data_3 || {},
                fn: function (ctx_4, data_4) {
                  var r = '';
                  r += '\n                        <div class="swiper-slide video-container" style="">\n                            <img src="';
                  r += c(ctx_4.thumb, ctx_4);
                  r += '" @click="openImage(';
                  r += c(data_4 && data_4.index, ctx_4);
                  r += ')" style="width: 100%;height: auto;">\n                            <div class="play-button-container">\n                                <div class="play-button">\n                                    <i class="icon material-icons">play_arrow</i>\n                                </div>\n                            </div>\n                        </div>\n                        ';
                  return r;
                },
                inverse: function (ctx_4, data_4) {
                  var r = '';
                  r += '\n                        <div class="swiper-slide">\n                            <img src="';
                  r += c(ctx_4.url, ctx_4);
                  r += '" @click="openImage(';
                  r += c(data_4 && data_4.index, ctx_4);
                  r += ')" style="width: 100%;height: auto;">\n                        </div>\n                        ';
                  return r;
                },
                root: root,
                parents: [ctx_2, ctx_1]
              });
              r += '\n                    ';
              return r;
            },
            inverse: function empty() {
              return '';
            },
            root: root,
            parents: [ctx_1]
          });
          r += '\n                </div>\n                <div class="swiper-pagination"></div>\n            </div>\n            ';
          return r;
        },
        inverse: function empty() {
          return '';
        },
        root: root,
        parents: [ctx_1]
      });
      r += '\n            <!--            <div class="" style="-->\n            <!--                 height: 300px; -->\n            <!--                 background-image: url();-->\n            <!--                 background-size: cover;background-position: center">-->\n            <!--                &lt;!&ndash;                <a href="#" class="link back color-white" style="position: absolute; right: 15px; top: 15px">-->\n            <!--                                    <i class="icon f7-icons">xmark_circle_fill</i>-->\n            <!--                                </a>&ndash;&gt;-->\n            <!--            </div>-->\n            <div class="block article-block no-hairlines padding-horizontal-half">\n                <bdi class="article-category" style="font-size: 13px;color: rgb(153,153,153)">';
      r += c(ctx_1.article.category, ctx_1);
      r += '</bdi>\n                <bdi class="article-title">';
      r += c(ctx_1.article.title, ctx_1);
      r += '</bdi>\n                <bdi class="article-subtitle">';
      r += c(ctx_1.article.subtitle, ctx_1);
      r += '</bdi>\n                <bdi class="">\n                    ';
      r += c(ctx_1.article.content, ctx_1);
      r += '\n                    ';
      r += Template7Helpers.if.call(ctx_1, ctx_1.article.external_link, {
        hash: {},
        data: data_1 || {},
        fn: function (ctx_2, data_2) {
          var r = '';
          r += '\n                    <a class="external button" data-id="';
          r += c(ctx_2.id, ctx_2);
          r += '" href="';
          r += c(ctx_2.article.external_link, ctx_2);
          r += '" target="_system">\n                        Read more\n                    </a>\n                    ';
          return r;
        },
        inverse: function empty() {
          return '';
        },
        root: root,
        parents: [ctx_1]
      });
      r += '\n                </bdi>\n            </div>\n        </div>\n    </div>\n';
      return r;
    }(this);
  },

  styleScoped: false
};
    